<div class="button-dashlet">
  <span>{{ dashlet.description }}</span>
  <div class="button-dashlet__button">
    <span *ngIf="loading" class="w-2rem"></span>
    <!-- Placeholder to counter spinner on the right; keeps button centered -->
    <button pButton [label]="dashlet.buttonLabel" (click)="performAction()" [disabled]="loading"></button>
    <p-progressSpinner *ngIf="loading" strokeWidth="6" class="button-dashlet__button__spinner"></p-progressSpinner>
  </div>
</div>
